//utils
import { combineComponents } from "../utils";
//contexts
import { AdminProvider } from "./admin";
import { NumbersProvider } from "./numbers";

const providers = [AdminProvider, NumbersProvider];

export const AppContextProvider: any = combineComponents(...providers);
